import { createRoutableExtension } from '@backstage/core-plugin-api';
import {
  catalogGraphPlugin,
  catalogGraphRouteRef,
} from '@backstage/plugin-catalog-graph';

export const C4CatalogGraphPageExtension = catalogGraphPlugin.provide(
  createRoutableExtension({
    name: 'C4CatalogGraphPage',
    component: () =>
      import('./components/C4CatalogGraphPage').then(m => m.C4CatalogGraphPage),
    mountPoint: catalogGraphRouteRef,
  }),
);
